import React from 'react';
import { connect } from 'react-redux';
import { GetEndUsers } from '../../Services/Actions';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import WeekMonthPicker from '../../Components/WeekMonthPicker';

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

const EndUsersColumns = [
    { field: 'UserId', headerName: 'UserId', flex: 0 },
    { field: 'DisplayName', headerName: 'End user', flex: 3 },
    { field: 'Segment', headerName: 'Segment', flex: 1 },
    { field: 'Product', headerName: 'Product', flex: 2 },
    { field: 'StatusType', headerName: 'Status', flex: 1 },
    { field: 'Frequency', headerName: 'Frequency', flex: 1 }
];

const pageSizeOptions = [ 10, 25, 50, { value: -1, label: 'All' } ];

class EndUsersComponent extends React.Component {
    state = {
        EndUsers: [],
        PageNo: 0,
        PageSize: 100,
        TotalRecords: 0,

        Sorting: [{
            field: 'DisplayName',
            sort: 'asc'
        }],

        SortingMode: 'server',

        EndDate: dayjs().endOf('isoWeek'),
        StartDate: dayjs().startOf('isoWeek'),

        SelectedDate: dayjs(),
        SelectedDate_Type: 'week'
    }

    componentDidMount() {
        this.onLoadEndUsers({});
    }

    onAdjustStartEndDates = () => {
        var { SelectedDate, SelectedDate_Type, StartDate, EndDate } = this.state;
    
        var date = dayjs(SelectedDate);
        var NewStartDate = SelectedDate_Type === 'week' ? date.startOf('isoWeek') : date.startOf('month');
        var NewEndDate = SelectedDate_Type === 'week' ? date.endOf('isoWeek') : date.endOf('month');
    
        if (!NewStartDate.isSame(StartDate) || !NewEndDate.isSame(EndDate)) {
            this.setState({ StartDate: NewStartDate, EndDate: NewEndDate }, () => this.onLoadEndUsers({}));
        }
    };
    

    onChangeSelectedDate_Type = event => {
        this.setState({ SelectedDate_Type: event.target.value }, () => this.onAdjustStartEndDates());
    }

    onLoadEndUsers = ({ page: PageNo, pageSize: PageSize }) => {
        PageNo = PageNo !== undefined ? PageNo : this.state.PageNo;
        PageSize = PageSize !== undefined ? PageSize : this.state.PageSize;

        PageNo++;

        var { EndDate, Sorting, StartDate } = this.state;

        EndDate = EndDate.format('YYYY-MM-DD');
        StartDate = StartDate.format('YYYY-MM-DD');

        if (Sorting.length) var { field: SortCol, sort: SortDir } = Sorting[0];

        this.props.GetEndUsers({ EndDate, PageNo, PageSize, SortCol, SortDir, StartDate }).then(({ EndUsers, TotalRecords }) => {
            var SortingMode = (PageSize === -1 || (EndUsers.length >= TotalRecords)) ? 'client' : 'server';
            this.setState({ EndUsers, SortingMode, TotalRecords });
        })
    }

    onSelectNewDate = SelectedDate => {
        this.setState({ SelectedDate }, () => this.onAdjustStartEndDates());
    }

    onSortColumns = data => {
        this.setState({ Sorting: [ ...data ] }, () => {
            if (this.state.SortingMode === 'server') this.onLoadEndUsers({});
        });
    }

    onUpdatePaginationModel = ({ page, pageSize }) => {
        this.setState({ PageNo: page, PageSize: pageSize }, () => this.onLoadEndUsers({}));
    }

    renderDatePicker = () => {
        var { SelectedDate, SelectedDate_Type } = this.state;

        return (
            <>
                <WeekMonthPicker OnSelectNewDate={this.onSelectNewDate} SelectedDate={SelectedDate} SelectedDate_Type={SelectedDate_Type} />

                <FormControl
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center', // Ensures label is centered
                    }}
                >
                    <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={SelectedDate_Type}
                        onChange={this.onChangeSelectedDate_Type}
                    >
                        <FormControlLabel value="week" control={<Radio />} label="Week" />
                        <FormControlLabel value="month" control={<Radio />} label="Month" />
                    </RadioGroup>
                </FormControl>
            </>
        );
    }

    renderEndUsersTable = () => {
        var { EndUsers, PageNo, PageSize, SortingMode, TotalRecords } = this.state;

        return (
            <DataGrid
                rows={EndUsers}
                columns={EndUsersColumns}
                rowCount={TotalRecords}
                getRowId={row => row.UserId}
                // loading={this.props.TryingGetData}
                paginationMode="server"
                paginationModel={{ page: PageNo, pageSize: PageSize }}
                onPaginationModelChange={this.onUpdatePaginationModel}
                pageSizeOptions={pageSizeOptions}
                sortingMode={SortingMode}
                onSortModelChange={this.onSortColumns}
                sortModel={this.state.Sorting}

                // onRowClick={({ row }) => this.onToggleShowEditPopup({ ShowEditPopup: true, ShowEditPopup_Data: row })}
            />
        );
    }

    render() {
        return (
            <>
                <Typography variant="h4" gutterBottom>
                    All EndUsers
                </Typography>

                <Box sx={{ height: 20 }} />

                {
                    this.props.TryingGetData &&
                    <Backdrop
                        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                        open={this.props.TryingGetData}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }

                {this.renderDatePicker()}

                <Box sx={{ height: 20 }} />

                {this.renderEndUsersTable()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        UserDetails: state.Auth.UserDetails,

        TryingGetData: state.Regular.TryingGetData,
        TryingGetDataError: state.Regular.TryingGetDataError
    }
}

export default connect(mapStateToProps, { GetEndUsers })(EndUsersComponent);